enum Titulos {
	INICIO_TRABAJADOR = 'Inicio',
	MIS_SINIESTROS = 'Mis siniestros',
	CAPACITACIONES_ELEARNING = 'Capacitaciones e-learning',
	RESULTADOS_EXAMENES_SALUD = 'Resultados exámenes de salud',
	ESTADOS_DE_PAGOS = 'Estados de pagos',
	MUNDO_ACHS_TRABAJADOR = 'Mundo ACHS',
	CONFIGURACION = 'Configuración',
	MI_PERFIL = 'Mi perfil',
	EMPRESAS_VINCULADAS = 'Mis empresas vinculadas',
	CENTRO_AYUDA = 'Centro de ayuda',
	TOUR_GUIADO = 'Tour guiado',
	MATERIAL_SOPORTE = 'Material soporte',
	NECESITAS_AYUDA = '¿Necesitas ayuda?',
	INICIO_EMPRESA = 'Inicio',
	EMPRESA_GESTION_SEGURO = 'Empresa y gestión del seguro',
	DATOS_EMPRESA = 'Datos empresa',
	COTIZACIONES = 'Cotizaciones',
	CERTIFICADOS_EMPRESA = 'Certificados empresa',
	DECRETO_SUPREMO_67 = 'Decreto supremo N°67',
	DEVOLUCIONES = 'Devoluciones',
	MUNDO_ACHS_EMPRESA = 'Mundo ACHS',
	ADMIN_USUARIOS_TRABAJADORES = 'Administración de usuarios y trabajadores',
	GESTION_USUARIOS = 'Gestión de usuarios',
	GESTION_CURSOS_ELEARNING = 'Gestión de cursos e-learning',
	GESTION_PREVENTIVA = 'Gestión preventiva',
	ACHS_GESTION = 'ACHS Gestión',
	AGENDAMIENTO_EXPERTO = 'Agendamiento experto',
	LESIONES_GRAVES_FATALES = 'Lesiones graves y fatales',
	PLAN_MOVILIDAD = 'Plan de movilidad',
	PLATAFORMA_PSICOSOCIAL = 'Plataforma psicosocial',
	AUTOEVALUACION_LEGAL = 'Autoevaluación legal',
	TMERT = 'Tmert',
	SAC = 'SAC',
	ACCIDENTES_ENFERMEDADES = 'Accidentes y enfermedades',
	SINIESTROS_EMPRESA = 'Siniestros empresa',
	DENUNCIAS = 'Denuncias',
	ESTADISTICAS = 'Estadísticas',
	PRESTACIONES_ECONOMICAS = 'Prestaciones económicas',
	COVID_19 = 'COVID-19',
	SEL = 'SEL',
	MANTENEDOR_SEL = 'Mantenedor SEL',
	CERRAR_SESION = 'Cerrar sesión',
	SOPORTE_DE_USUARIOS = 'Soporte de usuarios',
	CITAS_MEDICAS = 'Mis citas médicas',
	SWITCH_MUNDO_PREVENTIVO = 'Prevención',
	SAP_PORTAL_USER = 'SAPPortalUser',
	RUT_EMPRESA = 'rutEmpresa',
	TOMAR_SESION = 'Tomar sesión',
}

export default Titulos;
